/* eslint-disable */
import React from 'react';
import { sendMsgToExt } from 'util/messagePassing';
import { outbound } from 'extActions';

export function useInitialMsgsToExtension(user) {
	React.useEffect(
		() => {
			/**
			 * As soon as the user is authenticated, the following information must be passed to the extension:
			 * - React application is ready to accept user requests
			 * - User's preferred phone number detection country
			 * - User's blacklisted domains where phone numbers will not be highlighted
			 *
			 * TODO: Consolidate these message-passing in one request.
			 */
			if (user.id) {
				const { preferredPhoneRegions, blacklistedDomains } = user.preferences;
				const countryCode = preferredPhoneRegions.length ? preferredPhoneRegions[0] : 'default';
				sendMsgToExt({ action: outbound.APP_READY });
				sendMsgToExt({
					action: outbound.SET_PHONE_NUMBER_DETECTION,
					additionalData: { countryCode }
				});
			}
		},
		[user.id]
	);
}
